import { cn } from "@/lib/utils";
import { PlanetMark } from "@/components/planet-mark";

/**
 * Branded loading state — the Pyng logo mark itself, animated: the open bowl
 * of the "p" draws around and the signal dot pulses.
 */
export function PyngLoader({
  caption,
  fullscreen,
  size = 72,
  className,
}: {
  caption?: string;
  fullscreen?: boolean;
  size?: number;
  className?: string;
}) {
  const mark = (
    <div className="flex flex-col items-center gap-3">
      <PlanetMark size={size} animated />
      {caption && <p className="text-[13px] text-muted-foreground">{caption}</p>}
    </div>
  );

  if (!fullscreen) {
    return <div className={cn("flex w-full items-center justify-center py-16", className)}>{mark}</div>;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={caption ?? "Loading"}
      className={cn(
        "flex min-h-screen items-center justify-center bg-background animate-in fade-in duration-200",
        className,
      )}
    >
      {mark}
    </div>
  );
}

export default PyngLoader;
